import { Link, useLocation } from 'react-router-dom'
import { Header } from '../Header'
import FundraisingBlack from './fundraising-regulator-black.svg'
import FundraisingWhite from './fundraising-regulator-white.png'
import { type FC } from 'react'
import { Navigation } from '~/navigation/navigation'

const footerLinks: Array<{ name: string, url: string }> = [
  { name: 'About us', url: 'https://about.shamaazi.com/mytendays/about-us' },
  { name: 'Fees', url: 'https://about.shamaazi.com/mytendays/fees' },
  { name: 'FAQs', url: 'https://about.shamaazi.com/mytendays/faq' },
  { name: 'Terms & Conditions', url: 'https://about.shamaazi.com/mytendays/terms-and-conditions' },
  { name: 'Privacy Policy', url: 'https://about.shamaazi.com/mytendays/privacy-policy' },
  { name: 'Cookie Preferences', url: 'cookie-preferences' },
  { name: 'MTD Fund', url: 'https://about.shamaazi.com/mytendays/fund-terms-and-conditions' },
  { name: 'Contact Us', url: 'https://about.shamaazi.com/mytendays/contact-us' },
  { name: 'Charity Registration', url: 'https://charity.shamaazi.com' }
]

const Footer: FC = () => {
  const location = useLocation()
  const displayFullFooterPaths = [Navigation.home(), '']
  const currentPath = location.pathname
  const isFullFooter = displayFullFooterPaths.includes(currentPath) || !currentPath

  return <footer className={`${isFullFooter ? 'py-10 px-4' : 'p-6'} column ${isFullFooter ? 'bg-mtd-secondary' : 'bg-bluegray-50'} text-white`}>
    {isFullFooter ? <div className="max-w-fg-page mx-auto">
      <nav className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-4 gap-x-6 font-medium text-mtd-label">
        {footerLinks.map((link, index) => (
          <Link className={`text-white leading-none hover:underline ${index % 2 === 0 ? 'text-right sm:text-left' : 'text-left'}`} to={link.url}>{link.name}</Link>
        ))}
      </nav>

      <div className="mt-12 px-4 md:px-0 flex flex-col items-center md:items-start sm:flex-row gap-y-4 gap-x-10">
        <img className="w-32 sm:mb-0" src={FundraisingWhite} alt="Fundraising Regulator" />
        <div className={`text-xs text-center md:text-left text-mtd-gray-3`}>
          <p className="mb-3">
            Shamaazi trading as MyTenDays. <Link className="text-mtd-yellow" to="/privacy-policy">
              Privacy Statement
            </Link>, Company Registration No: 10622013.
            Head Office: 6-8 Great Eastern Street, London, United Kingdom, EC2A 3NT, United Kingdom. Disclaimer: Shamaazi is not
            affiliated with any external web sites. Shamaazi is not responsible for the content of external internet
            sites and any links from external web sites to this site do not constitute an endorsement of that site
            by Shamaazi.
          </p>
          <p>
            © Copyright {new Date().getFullYear()} MyTenDays. All rights reserved.
          </p>
        </div>
      </div>
    </div> : <div className="flex gap-x-4 justify-center items-center">
      <img className="w-32 sm:mb-0" src={FundraisingBlack} alt="Fundraising Regulator" />
      <span className="text-xs text-mtn-blue-550">
        © Copyright {new Date().getFullYear()} MyTenDays. All rights reserved.
      </span>
    </div>}
  </footer>
}

export default Footer

export const FooterLayout: FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="min-h-screen flex flex-col">
    <Header />
    <main className="flex-1 bg-mtd-bg">
      {children}
    </main>
    <Footer />
  </div>
}
